<!--  -->
<template>
  <div>
    <div style="display: flex">
      <div
        style="width: 256px; height: 350px; position: relative"
        :id="'tupian' + i"
        :ref="'tupian' + i"
        v-for="(item, i) in arr"
        :key="i"
      >
        <div>
          <img src="@/assets/hongse.png" alt="" />
        </div>
        <div class="content">
          <div class="title">
            <div class="top-bg">
              <img style="width: 37px; height: 22px" src="@/assets/bg1.png" alt="" />
            </div>
            <span class="title-content">{{ item }}</span>
            <div class="bottom-bg">
              <img style="width: 37px; height: 22px" src="@/assets/bg2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div @click="shengcheng">生成</div>
    <!--  excel表格上传  -->
    <el-upload
      class="upload-demo"
      drag
      action="https://jsonplaceholder.typicode.com/posts/"
      multiple
      accept=".xlsx"
      :on-exceed="exceed"
      :limit="1"
      :on-remove="remove"
      :http-request="uploadFile"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        将文件拖到此处，或
        <em>点击上传</em>
      </div>
      <div class="el-upload__tip" slot="tip">1次只能上传1个xls文件，且不超过500kb</div>
    </el-upload>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import XLSX from "xlsx";
export default {
  data() {
    return {
      name: "神农本神",
      arr: [],
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    shengcheng() {
      this.arr.forEach((item, index) => {
        let divText = "tupian" + index;
        this.saveImage(divText, item);
      });
    },
    //图片格式转换方法
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    //点击方法
    saveImage(divText, imgText) {
      console.log();
      let canvasID = this.$refs[divText][0];
      let that = this;
      let a = document.createElement("a");
      html2canvas(canvasID, {
        dpi: window.devicePixelRatio * 2,
        scale: 2,
        useCORS: true,
      }).then((canvas) => {
        let dom = document.body.appendChild(canvas);
        dom.style.display = "none";
        a.style.display = "none";
        document.body.removeChild(dom);
        let blob = that.dataURLToBlob(dom.toDataURL("image/png"));
        a.setAttribute("href", URL.createObjectURL(blob));
        //这块是保存图片操作  可以设置保存的图片的信息
        a.setAttribute("download", imgText + ".png");
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(blob);
        document.body.removeChild(a);
      });
    },
    //解析excel
    async uploadFile(params) {
      console.log(params);
      const _this = this;
      const _file = params.file;
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          console.log(workbook.Sheets);
          for (let sheet in workbook.Sheets) {
            //循环读取每个文件
            const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet]);
            console.log(sheetArray);
            //若当前sheet没有数据，则continue
            if (sheetArray.length == 0) {
              continue;
            }
            console.log("读取文件");
            console.log(sheetArray);
            sheetArray.forEach((item, index) => {
              //   _this.name = item.书名;
              _this.arr.push(item.书名);
            });
            this.$forceUpdate;
            // for (let item in sheetArray) {
            //   let rowTable = {};
            //   //这里的rowTable的属性名注意要与上面表格的prop一致
            //   //sheetArray的属性名与上传的表格的列名一致
            //   rowTable.name = sheetArray[item].姓名;
            //   rowTable.age = sheetArray[item].年龄;
            //   this.listTable.push(rowTable);
            // }
          }
        } catch (e) {
          this.$message.warning("文件类型不正确！");
        }
      };
      fileReader.readAsBinaryString(_file);
    },
    //上传1个以上文件时弹窗提示错误
    exceed: function () {
      this.$message.error("最多只能上传1个xls文件");
    },
    //删除文件
    remove() {
      this.listTable = [];
    },
  },
};
</script>
<style scoped>
/* @import url(); 引入css类 */
.content {
  top: 8px;
  left: 8px;
  position: absolute;
  max-height: 266px;
  border-radius: 6px;
  border: 2px solid #ffffff;
  padding: 6px;
}
.title {
  background: #ffffff;
  border-radius: 4px;
  writing-mode: vertical-lr;
  writing-mode: tb-lr;
  font-size: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-content {
  font-size: 30px;
  font-weight: 500;
  margin-left: 10px;
}
.top-bg {
  position: absolute;
  width: 100%;
  top: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bottom-bg {
  position: absolute;
  width: 100%;
  bottom: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
